/* The registered entry point for the 3D surface view.
 *
 * Viewpoint mode only, like the other views added since the viewpoint work landed. The view is
 * not offered in workspace mode at all, so there is no mode branch here - the alternative would
 * be a second source-data path reading the Backbone interfaces, for a beta nobody has asked to
 * use that way. `readers.ts` already carries the adapter for the day that changes. */

import { connect } from '@ardoq/rxbeach';
import styled from 'styled-components';
import { Surface3DView } from './Surface3DView';
import { surface3dViewModel$ } from './viewModel$/surface3dViewModel$';

/**
 * Grows to fill the view pane, which is itself a `flex: 1` column with `flex-basis: 0`.
 *
 * A `height: 100%` box here has nothing definite to resolve against and collapses; growing as a
 * flex item does, and `min-height: 0` lets it shrink past its content so the canvas follows the
 * pane rather than forcing it open.
 */
const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ConnectedSurface3DView = connect(Surface3DView, surface3dViewModel$);

export const Surface3DViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedSurface3DView />
  </ViewRoot>
);
